var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SylEditorService } from '@syllepsis/editor';
import React from 'react';
import { moduleOption } from './modules/utils';
import { ReactRenderer } from './render-bridge';
var SylEditor = /** @class */ (function (_super) {
    __extends(SylEditor, _super);
    function SylEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mountDOM = React.createRef();
        _this.editor = null;
        return _this;
    }
    SylEditor.prototype.componentDidMount = function () {
        if (!this.editor && this.mountDOM && this.mountDOM.current) {
            this.handleModule(this.props.module);
            this.editor = SylEditorService.init(this.mountDOM.current, this.props);
        }
    };
    SylEditor.prototype.handleModule = function (modulesConfig) {
        if (modulesConfig) {
            Object.keys(modulesConfig).forEach(function (key) {
                if (!modulesConfig[key].option)
                    return;
                modulesConfig[key].option = __assign(__assign({ RenderBridge: ReactRenderer }, moduleOption[key]), modulesConfig[key].option);
            });
        }
    };
    SylEditor.prototype.shouldComponentUpdate = function (nextProps) {
        if (!this.editor || this.editor.isDestroy)
            return true;
        SylEditorService.updateConfig(this.editor, nextProps);
        return true;
    };
    SylEditor.prototype.render = function () {
        return React.createElement("div", { className: "syl-editor", ref: this.mountDOM, style: { position: 'relative' } });
    };
    SylEditor.prototype.componentWillUnmount = function () {
        if (this.editor) {
            this.editor.uninstall();
        }
    };
    return SylEditor;
}(React.Component));
export { SylEditor };
//# sourceMappingURL=Editor.js.map